import { captureReactException } from '@sentry/react';
import { type ErrorComponentProps } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import appCss from '@/index.css?url';
import { VITE_META_DEV } from '@/lib/constants';

function ErrorPrint({ error, info, reset }: ErrorComponentProps) {
  const { t } = useTranslation();
  useEffect(() => {
    captureReactException(error, info ?? {});
  }, [error, info]);
  return (
    <>
      <script>
        {`
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = '${appCss}';
          document.head.appendChild(link);
        `}
      </script>
      <div className="min-h-svh grid place-items-center p-4">
        <Card className="max-w-lg w-full">
          <CardHeader>
            <CardTitle>{t('errors.somethingWentWrong')}</CardTitle>
            <CardDescription>{t('errors.unexpectedError')}</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            {VITE_META_DEV && error && (
              <details className="text-sm bg-muted p-4 rounded-md">
                <summary className="cursor-pointer font-medium">
                  {t('errors.errorDetails')}
                </summary>
                <pre className="mt-2 whitespace-pre-wrap text-xs">
                  {error.message}
                </pre>
                {error.stack && (
                  <pre className="mt-2 whitespace-pre-wrap text-xs opacity-70">
                    {error.stack}
                  </pre>
                )}
              </details>
            )}
            <div className="flex gap-2">
              <Button onClick={reset} variant="outline">
                {t('common.tryAgain')}
              </Button>
              <Button onClick={() => window.location.reload()}>
                {t('common.reloadPage')}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
}

export default ErrorPrint;
